.card {
  cursor: pointer;
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--tuna-palette-background-default);
  border-radius: var(--tuna-shape-borderRadius);
  transition:
    background-color 0.2s,
    opacity 0.2s;
}

.card:hover {
  background-color: var(--tuna-palette-action-hover) !important;
  border-radius: var(--tuna-shape-borderRadius);
}

.hasImage:hover {
  opacity: 0.7;
}

.backgroundImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.headerOverlay {
  background-color: rgba(var(--tuna-palette-background-paper-channel), 0.8);
  z-index: 1;
}

.headerContent {
  flex: 1;
  overflow: hidden;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mediaContent {
  flex: 1;
  cursor: pointer;
  max-height: 300px;
  padding: 16px;
}

.mediaContentOverlay {
  z-index: 1;
  background-color: rgba(var(--tuna-palette-background-paper-channel), 0.8);
}

.dropHover {
  border-color: var(--tuna-palette-success-main);
  border-width: 8px;
  border-style: dashed;
}

.actions {
  display: flex;
  align-items: center;
  padding: 8px;
}

.headerActions {
  align-items: center;
  padding-left: 8px;
}

/* The card's "more" action stays visible at low opacity so it is reachable
 * by touch and visible to screen readers; it lifts to full opacity when the
 * card is hovered or the button itself receives keyboard focus. The previous
 * opacity:0-on-hover-only pattern hid the action entirely on touch and from
 * keyboard users until first interaction. */
.menuButton {
  cursor: pointer;
  opacity: 0.4;
  transition: opacity 0.2s;
}

.card:hover .menuButton,
.menuButton:hover,
.menuButton:focus-visible {
  opacity: 1;
}
